import { HubspotObjectTypeEnum } from 'shared/domains/apollo/generated/types';
const EXTERNAL_SOURCE = 'hubspot';
const OBJECT_TYPE_BY_ID = {
    '0-1': HubspotObjectTypeEnum.Contact,
    '0-2': HubspotObjectTypeEnum.Company,
    '0-3': HubspotObjectTypeEnum.Deal,
};
export const parseHubspotConnectionId = (externalSource) => {
    if (!externalSource) {
        return undefined;
    }
    const [source, connectionId] = externalSource.split(':');
    if (source !== EXTERNAL_SOURCE || !connectionId) {
        return undefined;
    }
    return connectionId;
};
/**
 * Parses the externalId emitted by the backend in the form `<objectTypeId>:<objectId>`,
 * e.g. `0-1:12345`. The object type id resolves which HubSpot object the document is
 * attached to (a single template can be mapped to different object types), and the
 * objectId is the HubSpot record id used when pushing field values.
 */
export const parseHubspotExternalId = (externalId) => {
    if (!externalId) {
        return undefined;
    }
    const [objectTypeId, objectId] = externalId.split(':');
    const objectType = OBJECT_TYPE_BY_ID[objectTypeId];
    if (!objectType || !objectId) {
        return undefined;
    }
    return { objectType, objectId };
};
